<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

	<nav class="toolbar navbar navbar-light">
		<div class="form-inline">
			<button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
			<button *ngIf="!visibilitySpinnerGuardar" [disabled]="!habilitarGuardar" (click)="saveSolicitud()" type="button" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
			<button *ngIf="visibilitySpinnerGuardar" [disabled]="true" class="btn btn-outline-success">
				<p-progressSpinner class="spinnerExcel"></p-progressSpinner>
				Guardando
			</button>
		</div>
	</nav>


	<div class="animated fadeIn container-fluid">		
		<h4 style="display:inline">{{editTitle}} Solicitud de Importación {{form.value.Codigo}}</h4>
		<h5 style="display:inline; margin-left: 8px">
			<span>
				<!--***ICONOS***-->
				<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />
				<!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
				<label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{codigoTipoSolicitud}}</label>
				<img class="estado-icono-big" container="body"  src="{{form.value.IdEstadoSolicitud | IconoEstadoSolicitud}}" ngbTooltip="{{tituloEstadoSolicitud}}" />
				<img class="predua-icono-big" container="body"  ngbTooltip="{{esPredua | preduaNoPredua}}" src="{{esPredua | IconoPreduaSolicitud}}" />
				<img *ngIf="esClonada" class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="Clonada" />
				<i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>

			</span>
		</h5>

		<div class="row">
			<div class="col-md-12">

				<!--DATOS SOLICITUD-->
				<div class="card card-accent-success animated fadeIn">

					<a class="card-header-a" (click)="isCollapsedDatosSolicitud = !isCollapsedDatosSolicitud" [attr.aria-expanded]="!isCollapsedDatosSolicitud"
					   aria-controls="collapseExample">
						<div class="card-header-buscador">
							<i class="fa fa-file-text-o"></i> Datos Solicitud
							<i *ngIf="isCollapsedDatosSolicitud" class="fa fa-caret-down float-right"></i>
							<i *ngIf="!isCollapsedDatosSolicitud" class="fa fa-caret-up float-right"></i>
						</div>
					</a>
					<div class="card-body-detalle">

						<div class="collapse group-campos" id="isCollapsedDatosSolicitud" [ngbCollapse]="isCollapsedDatosSolicitud">

							<div class="row">

								<div class="form-group col-md-6">
									<label class="col-form-label required-field" for="inpDescripcion">Nº Solicitud</label>
									<input readonly [attr.disabled]="true ? '' : null" formControlName="Codigo" name="Codigo" title=""
										   maxlength="50" class="form-control" id="inpCodigo" type="text" value="">

								</div>

								<div class="form-group col-md-6">
									<label class="col-form-label" for="intZona">Estado</label>

									<ng-select loadingText="Cargando..."
											   [items]="listEstadoSolicitud"
											   bindLabel="Descripcion"
											   bindValue="Id"
											   formControlName="IdEstadoSolicitud"
											   [readonly]="!listEstadoSolicitud || listEstadoSolicitud.length === 0"
											   [loading]="!listEstadoSolicitud || listEstadoSolicitud.length === 0"
											   notFoundText="Estado no encontrado"
											   placeholder="-- Seleccione un Estado --"
											   clearAllText="Eliminar selección"
											   [ngClass]="displayFieldCssNgSelect('IdEstadoSolicitud')">
									</ng-select>
								</div>

							</div>
						</div>
					</div>

				</div>


				<div class="row">
					<div class="col-md-12">
						<!--TASAS-->
						<div class="card card-accent-success animated fadeIn">

							<a class="card-header-a" (click)="isCollapsedTasas = !isCollapsedTasas" [attr.aria-expanded]="!isCollapsedTasas"
							   aria-controls="collapseExample">
								<div class="card-header-buscador">
									<i class="fa fa-file-text-o"></i> Tasas
									<i *ngIf="isCollapsedTasas" class="fa fa-caret-down float-right"></i>
									<i *ngIf="!isCollapsedTasas" class="fa fa-caret-up float-right"></i>
								</div>
							</a>
							<div class="card-body-detalle">

								<div class="collapse group-campos" id="isCollapsedTasas" [ngbCollapse]="isCollapsedTasas">

									<div class="row">

										<div class="form-group col-md-3">
											<label class="col-form-label required-field" for="inpTotalTasas">Importe Tasa (€)</label>
											<input formControlName="TotalTasas" maxlength="18" name="TotalTasas" title="" class="form-control" [ngClass]="displayFieldCssNoSubmit('TotalTasas')" id="inpTotalTasas" type="text" value="">

											<div class="invalid-feedback" *ngIf="isFieldInvalidNoSubmit('TotalTasas','required')">
												El importe de la tasa es obligatorio
											</div>
											<div class="invalid-feedback" *ngIf="isFieldInvalidNoSubmit('TotalTasas','pattern')">
												Formato incorrecto
											</div>

										</div>

										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpFechaLiquidacion">Fecha Liquidación</label>
											<p-calendar formControlName="FechaLiquidacion" inputStyleClass="form-control" utc="true" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
											<!--<input formControlName="FechaLiquidacion" name="FechaLiquidacion" title="" class="form-control" id="inpDescripcion" type="date" value="">-->
										</div>

										<div class="form-group col-md-6">
											<label class="col-form-label" for="inpNumeroLiquidacion">Nº Liquidación</label>
											<div class="input-group">
												<input formControlName="NumeroLiquidacion" maxlength="13" name="NumeroLiquidacion" title="" class="form-control" [ngClass]="displayFieldCssNoSubmit('NumeroLiquidacion')" id="inpDescripcion" type="text" value="">
												<div class="invalid-feedback" *ngIf="isFieldInvalidNoSubmit('NumeroLiquidacion','pattern')">
													Formato incorrecto.
												</div>

												<span class="input-group-btn">
													&nbsp;<button name="btnAddTasa" class="btn btn-list btn-secondary" type="button" title="Añade una Tasa" (click)="onAddTasa()"><i class="fa fa-plus"></i></button>
												</span>
											</div>
										</div>

									</div>

									<div class="row">
										<div class="col-md-12">
											<div class="card card-interior">

												<div class="card-header">
													<i class="fa fa-align-justify"></i> Listado
												</div>

												<div class="card-body">
													<table class="table table-responsive table-sm">
														<thead class="col-md-12">
															<tr>
																<th></th>
																<th>Importe Tasa (€)</th>
																<th>Fecha Liquidación</th>
																<th>Nº Liquidación</th>
															</tr>
														</thead>
														<tbody>
															<tr *ngFor="let item of solicitud.TTasaCollection">
																<td>
																	<div class="btn-group">

																		<button (click)="onDeleteTasa(item)" title="Borrar"
																				class="btn btn-sm btn-danger">
																			<span class="fa fa-remove"></span>

																		</button>
																	</div>
																</td>
																<td>{{item.TotalTasas | number:'1.2-2'}}</td>
																<td>{{item.FechaLiquidacion | date:'dd/MM/yyyy'}}</td>
																<td>{{item.NumeroLiquidacion}}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12">
						<!--EXPORTADOR-->
						<div class="card card-accent-success animated fadeIn">

							<a class="card-header-a" (click)="isCollapsedExportador = !isCollapsedExportador" [attr.aria-expanded]="!isCollapsedExportador"
							   aria-controls="collapseExample">
								<div class="card-header-buscador">
									<i class="fa fa-file-text-o"></i> Exportador
									<i *ngIf="isCollapsedExportador" class="fa fa-caret-down float-right"></i>
									<i *ngIf="!isCollapsedExportador" class="fa fa-caret-up float-right"></i>
								</div>
							</a>
							<div class="card-body-detalle">

								<div class="collapse group-campos" id="isCollapsedExportador" [ngbCollapse]="isCollapsedExportador">

									<div class="row">

										<div class="form-group col-md-4">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="inpNombreExportador">Nombre</label>
											<input formControlName="NombreExportador" name="NombreExportador" title="" class="form-control" [ngClass]="displayFieldCssNoSubmit('NombreExportador')"
												   maxlength="300" id="inpNombreExportador" type="text" value="">

											<div class="invalid-feedback" *ngIf="isFieldInvalid('NombreExportador','required')">
												Nombre Exportador es obligatorio
											</div>
										</div>

										<div class="form-group col-md-4">
											<label class="col-form-label" for="inpPais" [ngClass]="{ 'required-field' : campoObligatorio }">País</label>

											<ng-select [items]="listPais"
													   bindLabel="Descripcion"
													   bindValue="Id"
													   formControlName="IdPaisExportador"
													   loadingText="Cargando..."
													   [readonly]="!listPais || listPais.length === 0"
													   [loading]="!listPais || listPais.length === 0"
													   notFoundText="País no encontrado"
													   placeholder="-- Seleccione un País --"
													   clearAllText="Eliminar selección"
													   [ngClass]="displayFieldCssNgSelect('IdPaisExportador')"
													   (change)="onSelectPaisExportador()">
												>
												<ng-template ng-option-tmp let-item="item">
													<div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
												</ng-template>

											</ng-select>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisExportador','required')">
												País es obligatorio
											</div>
										</div>


										<div class="form-group col-md-4">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="inpCiudad">Ciudad</label>
											<input formControlName="CiudadExportador" name="CiudadExportador" title="" class="form-control" [ngClass]="displayFieldCssNoSubmit('CiudadExportador')"
												   maxlength="100" id="inpCiudad" type="text" value="">

											<div class="invalid-feedback" *ngIf="isFieldInvalid('CiudadExportador','required')">
												Ciudad es obligatoria
											</div>
										</div>
									</div>

									<div class="row">

										<div class="form-group col-md-8">
											<label class="col-form-label" for="inpDireccionExportador">Dirección</label>
											<input formControlName="DireccionExportador" name="DireccionExportador" title="" class="form-control" [ngClass]="displayFieldCssNoSubmit('DireccionExportador')"
												   maxlength="250" id="inpDireccionExportador" type="text" value="">

										</div>

										<div class="form-group col-md-4">
											<label class="col-form-label" for="inpCodigoPostal" [ngClass]="{ 'required-field' : usaCodigoPostalPaisExportador && campoObligatorio }">Código Postal</label>
											<input class="form-control" formControlName="CodigoPostalExportador" maxlength="15"
												   inputStyleClass="form-control" id="inpCodPostalExportador"
												   value="" [ngClass]="displayFieldCss('CodigoPostalExportador')">
											<div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoPostalExportador','pattern')">
												Formato incorrecto
											</div>
											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoPostalExportador','required')">
												El Código Postal es obligatorio
											</div>

										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>

				<!--
				<div class="row">
					<div class="col-md-12" [hidden]="esImportadorExtranjero">
						<div class="card card-accent-success animated fadeIn">

							<a class="card-header-a" (click)="isCollapsedImportador = !isCollapsedImportador" [attr.aria-expanded]="!isCollapsedImportador"
							   aria-controls="collapseExample">
								<div class="card-header-buscador">
									<i class="fa fa-file-text-o"></i> Importador
									<i *ngIf="isCollapsedImportador" class="fa fa-caret-down float-right"></i>
									<i *ngIf="!isCollapsedImportador" class="fa fa-caret-up float-right"></i>
								</div>
							</a>
							<div class="card-body-detalle">
								<div class="collapse group-campos" id="isCollapsedImportador" [ngbCollapse]="isCollapsedImportador">
									<div class="row">
										<div class="form-group col-md-3">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="inpDescripcion">NIF/NIE</label>
											<input formControlName="NIF" name="NIF" title="" class="form-control" [ngClass]="displayFieldCss('NIF')" id="" maxlength="17" type="text" value="">

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIF','required')">
												NIF es obligatorio
											</div>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIF','NIF')">
												Formato de NIF incorrecto
											</div>
										</div>
										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpDescripcion" [ngClass]="{ 'required-field' : campoObligatorio }">Nº Reg.</label>
											<input formControlName="NRegistro" name="NRegistro" title="" class="form-control" [ngClass]="displayFieldCss('NRegistro')" id="inpNRegistro" type="text" maxlength="50" value="">

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NRegistro','required')">
												Nº Reg. es obligatorio, valide el NIF
											</div>

										</div>

										<div class="form-group col-md-6">
											<label class="col-form-label" for="inpNombre">Nombre</label>
											<input formControlName="Nombre" name="Nombre" title="" class="form-control" id="inpNombre" maxlength="150" type="text" value="">
										</div>
									</div>

									<div class="row">
										<div class="form-group col-md-6">
											<label class="col-form-label" for="inpDireccion">Dirección</label>
											<input formControlName="Direccion" name="Direccion" title="" class="form-control" maxlength="150" id="inpDireccion" type="text" value="">
										</div>

										<div class="form-group col-md-3">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }">Localidad</label>
											<input formControlName="Localidad" name="Localidad" [ngClass]="displayFieldCss('Localidad')" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="150">

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Localidad','required')">
												Localidad es obligatoria
											</div>
										</div>

										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpCodigoPostal" [ngClass]="{ 'required-field' : usaCodigoPostalPaisImportador && campoObligatorio }">Código Postal</label>
											<input class="form-control" formControlName="CodigoPostalImportador" maxlength="15"
												   inputStyleClass="form-control" id="inpCodPostalImportador" value="" [ngClass]="displayFieldCss('CodigoPostalImportador')">

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoPostalImportador','required')">
												El Código Postal es obligatorio
											</div>
										</div>
									</div>

									<div class="row">

										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpRefTraces">Ref. Traces</label>
											<input class="form-control" formControlName="RefTraces" maxlength="50"
												   inputStyleClass="form-control" id="inpRefTraces" value="" [ngClass]="displayFieldCss('RefTraces')">
										</div>

										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpTipoRefTraces">Tipo Ref. Traces</label>
											<input class="form-control" formControlName="TipoRefTraces" maxlength="50"
												   inputStyleClass="form-control" id="inpTipoRefTraces" value="" [ngClass]="displayFieldCss('TipoRefTraces')">
										</div>

										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpOperadorTraces">OperadorTraces</label>
											<input class="form-control" formControlName="OperadorTraces" maxlength="50"
												   inputStyleClass="form-control" id="inpOperadorTraces" value="" [ngClass]="displayFieldCss('OperadorTraces')">
										</div>

										<div class="form-group col-md-3">
											<label class="col-form-label">Tipo Operador</label>
											<input formControlName="TipoOperador" name="TipoOperador" [ngClass]="displayFieldCss('TipoOperador')" title=""
												   class="form-control" id="TipoOperador" type="text" value="" maxlength="50">
										</div>

									</div>

								</div>
							</div>
						</div>
					</div>
					
					<div class="col-md-12" *ngIf="esImportadorExtranjero">
						
						<div class="card card-accent-success animated fadeIn">

							<a class="card-header-a" (click)="isCollapsedImportadorExtr = !isCollapsedImportadorExtr" [attr.aria-expanded]="!isCollapsedImportadorExtr"
							   aria-controls="collapseExample">
								<div class="card-header-buscador">
									<i class="fa fa-file-text-o"></i> Importador
									<i *ngIf="isCollapsedImportadorExtr" class="fa fa-caret-down float-right"></i>
									<i *ngIf="!isCollapsedImportadorExtr" class="fa fa-caret-up float-right"></i>
								</div>
							</a>
							<div class="card-body-detalle">

								<div class="collapse group-campos" id="isCollapsedImportadorExtr" [ngbCollapse]="isCollapsedImportadorExtr">

									<div class="row">
										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpDescripcion">Nº Reg.</label>
											<input formControlName="NRegistro" name="NRegistro" title="" class="form-control" maxlength="50" id="inpNregistro" type="text" value="">

										</div>
										<div class="form-group col-md-3">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="inpDescripcion">EORI/NIF</label>
											<input formControlName="NIF" name="NIF" [ngClass]="displayFieldCss('NIF')" title="" class="form-control" id="" maxlength="17" type="text" value="">

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIF','required')">
												EORI/NIF es obligatorio
											</div>

										</div>

										<div class="form-group col-md-6">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="inpNombre">Nombre</label>
											<input formControlName="Nombre" name="Nombre" title="" class="form-control" id="inpNombre" maxlength="150" type="text" value="">

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Nombre','required')">
												Nombre es obligatorio
											</div>

										</div>
									</div>

									<div class="row">
										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpDireccion">Dirección</label>
											<input formControlName="Direccion" name="Direccion" title="" class="form-control" maxlength="150" id="inpDireccion" type="text" value="">

										</div>

										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpCodigoPostal" [ngClass]="{ 'required-field' : usaCodigoPostalPaisImportador && campoObligatorio }">Código Postal</label>
											<input class="form-control" formControlName="CodigoPostalImportador" maxlength="15"
												   inputStyleClass="form-control" id="inpCodPostalImportador"
												   value="" [ngClass]="displayFieldCss('CodigoPostalImportador')">

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('CodigoPostalImportador','required')">
												El Código Postal es obligatorio
											</div>
										</div>

										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpPais" [ngClass]="{ 'required-field' : campoObligatorio }">País</label>

											<ng-select [items]="listPaisImportador"
													   bindLabel="Descripcion"
													   bindValue="Id"
													   formControlName="IdPaisImportador"
													   loadingText="Cargando..."
													   [readonly]="!listPaisImportador || listPaisImportador.length === 0"
													   [loading]="!listPaisImportador || listPaisImportador.length === 0"
													   notFoundText="País no encontrado"
													   placeholder="-- Seleccione un País --"
													   clearAllText="Eliminar selección"
													   [ngClass]="displayFieldCssNgSelect('IdPaisImportador')"
													   (change)="onSelectPaisImportador()">
												<ng-template ng-option-tmp let-item="item">
													<div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
												</ng-template>

											</ng-select>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisImportador','required')">
												País es obligatorio
											</div>
										</div>

										<div class="form-group col-md-3">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="inpDescripcion">Localidad</label>
											<input formControlName="Localidad" name="Localidad" [ngClass]="displayFieldCss('Localidad')" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="150">

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Localidad','required')">
												Localidad es obligatoria
											</div>
										</div>

									</div>

									<div class="row">

										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpRefTraces">Ref. Traces</label>
											<input class="form-control" formControlName="RefTraces" maxlength="50"
												   inputStyleClass="form-control" id="inpRefTraces" value="" [ngClass]="displayFieldCss('RefTraces')">
										</div>

										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpTipoRefTraces">Tipo Ref. Traces</label>
											<input class="form-control" formControlName="TipoRefTraces" maxlength="50"
												   inputStyleClass="form-control" id="inpTipoRefTraces" value="" [ngClass]="displayFieldCss('TipoRefTraces')">
										</div>

										<div class="form-group col-md-3">
											<label class="col-form-label" for="inpOperadorTraces">OperadorTraces</label>
											<input class="form-control" formControlName="OperadorTraces" maxlength="50"
												   inputStyleClass="form-control" id="inpOperadorTraces" value="" [ngClass]="displayFieldCss('OperadorTraces')">
										</div>

										<div class="form-group col-md-3">
											<label class="col-form-label">Tipo Operador</label>
											<input formControlName="TipoOperador" name="TipoOperador" [ngClass]="displayFieldCss('TipoOperador')" title=""
												   class="form-control" id="TipoOperador" type="text" value="" maxlength="50">
										</div>

									</div>

								</div>
							</div>
						</div>
					</div>
				</div>
				-->

				<div class="row">
					<div class="col-md-12">
						<!--LUGARES REFERENTES A LA MERCANCIA-->
						<div class="card card-accent-success animated fadeIn">
							<a class="card-header-a" (click)="isCollapsedLugaresMercancia = !isCollapsedLugaresMercancia" [attr.aria-expanded]="!isCollapsedLugaresMercancia" aria-controls="collapseExample">
								<div class="card-header-buscador">
									<i class="fa fa-file-text-o"></i> Lugares referentes a la mercancía
									<i *ngIf="isCollapsedLugaresMercancia" class="fa fa-caret-down float-right"></i>
									<i *ngIf="!isCollapsedLugaresMercancia" class="fa fa-caret-up float-right"></i>
								</div>
							</a>
							<div class="card-body-detalle">
								<div class="collapse group-filtros" id="collapsedLugaresMercancia" [ngbCollapse]="isCollapsedLugaresMercancia">
									<div class="row">
										<div class="form-group col-md-3">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="intPais">País de Origen</label>
											<ng-select [items]="listPais"
													   bindLabel="Descripcion"
													   bindValue="Id"
													   formControlName="IdPaisOrigen"
													   loadingText="Cargando..."
													   [readonly]="!listPais || listPais.length === 0"
													   [loading]="!listPais || listPais.length === 0"
													   notFoundText="País no encontrado"
													   placeholder="-- Seleccione un País --"
													   [ngClass]="displayFieldCssNgSelect('IdPaisOrigen')"
													   clearAllText="Eliminar selección">
												<ng-template ng-option-tmp let-item="item">
													<div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
												</ng-template>

											</ng-select>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisOrigen','required')">
												País de Origen es obligatorio
											</div>
										</div>
										<div class="form-group col-md-3">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="intPais">País de Procedencia</label>
											<ng-select [items]="listPais"
													   bindLabel="Descripcion"
													   bindValue="Id"
													   formControlName="IdPaisProcedencia"
													   loadingText="Cargando..."
													   [readonly]="!listPais || listPais.length === 0"
													   [loading]="!listPais || listPais.length === 0"
													   notFoundText="País no encontrado"
													   placeholder="-- Seleccione un País --"
													   [ngClass]="displayFieldCssNgSelect('IdPaisProcedencia')"
													   clearAllText="Eliminar selección">
												<ng-template ng-option-tmp let-item="item">
													<div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
												</ng-template>

											</ng-select>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisProcedencia','required')">
												País de Procedencia es obligatorio
											</div>
										</div>
										<div class="form-group col-md-3">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="intPais">País de Destino</label>
											<ng-select [items]="listPais"
													   bindLabel="Descripcion"
													   bindValue="Id"
													   formControlName="IdPaisDestino"
													   loadingText="Cargando..."
													   [readonly]="!listPais || listPais.length === 0"
													   [loading]="!listPais || listPais.length === 0"
													   notFoundText="País no encontrado"
													   placeholder="-- Seleccione un País --"
													   [ngClass]="displayFieldCssNgSelect('IdPaisDestino')"
													   clearAllText="Eliminar selección">
												<ng-template ng-option-tmp let-item="item">
													<div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
												</ng-template>

											</ng-select>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisDestino','required')">
												País de Destino es obligatorio
											</div>
										</div>
									</div>

									<div class="row">
										<div class="form-group col-md-3">
											<label class="col-form-label" for="">Aduana de Despacho</label>
											<ng-select [items]="listAduana"
													   bindLabel="Descripcion"
													   bindValue="Id"
													   formControlName="IdAduana"
													   loadingText="Cargando..."
													   [readonly]="!listAduana || listAduana.length === 0"
													   [loading]="(!listAduana || listAduana.length === 0) && (IdPuntoInspeccion > 0)"
													   notFoundText="Aduana no encontrada"
													   placeholder="-- Seleccione una Aduana --"
													   [ngClass]="displayFieldCssNgSelect('IdAduana')"
													   clearAllText="Eliminar selección">
											</ng-select>
										</div>
										<div class="form-group col-md-3">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Ubicación</label>
											<ng-select [items]="listUbicacion"
													   bindLabel="Descripcion"
													   bindValue="Id"
													   formControlName="IdUbicacion"
													   loadingText="Cargando..."
													   [readonly]="!listUbicacion || listUbicacion.length === 0"
													   [loading]="(!listUbicacion || listUbicacion.length === 0) && (IdPuntoInspeccion > 0)"
													   notFoundText="Ubicación no encontrada"
													   placeholder="-- Seleccione una Ubicación --"
													   [ngClass]="displayFieldCssNgSelect('IdUbicacion')"
													   clearAllText="Eliminar selección">
											</ng-select>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdUbicacion','required')">
												Ubicación es obligatoria
											</div>
										</div>
										<div class="form-group col-md-3">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="inpFecha">Fecha Inspección</label>
											<p-calendar formControlName="FechaInspeccion" inputStyleClass="form-control" [ngClass]="displayFieldCssCal('FechaInspeccion')"
														[showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaInspeccion','required')">
												Fecha Inspeccion es obligatoria
											</div>
										</div>
										<div class="form-group col-md-3">
											<label class="col-form-label" for="">Hora Inspección</label>
											<ng-select [items]="listIntervalo"
													   bindLabel="HoraInicio"
													   bindValue="Id"
													   formControlName="IdIntervaloHoras"
													   loadingText="Cargando..."
													   [readonly]="!listIntervalo || listIntervalo.length === 0"
													   [loading]="(!listIntervalo || listIntervalo.length === 0) && (IdPuntoInspeccion > 0)"
													   notFoundText="Hora no encontrada"
													   placeholder="-- Seleccione Hora --"
													   clearAllText="Eliminar selección">
											</ng-select>
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12">
						<!--MEDIOS DE TRANSPORTE-->
						<div class="card card-accent-success animated fadeIn">
							<a class="card-header-a" (click)="isCollapsedMediosTransporte = !isCollapsedMediosTransporte" [attr.aria-expanded]="!isCollapsedMediosTransporte" aria-controls="collapseExample">
								<div class="card-header-buscador">
									<i class="fa fa-file-text-o"></i> Medios de transporte
									<i *ngIf="isCollapsedMediosTransporte" class="fa fa-caret-down float-right"></i>
									<i *ngIf="!isCollapsedMediosTransporte" class="fa fa-caret-up float-right"></i>
								</div>
							</a>
							<div class="card-body-detalle">
								<div class="collapse group-filtros" id="collapsedMediosTransporte" [ngbCollapse]="isCollapsedMediosTransporte">
									<div class="row">
										<div class="form-group col-md-3">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Tipo</label>
											<ng-select [items]="listMedioTransporte"
													   bindLabel="Descripcion"
													   bindValue="Id"
													   formControlName="IdMedioTransporte"
													   loadingText="Cargando..."
													   [readonly]="!listMedioTransporte || listMedioTransporte.length === 0"
													   [loading]="!listMedioTransporte || listMedioTransporte.length === 0"
													   notFoundText="Tipo no encontrado"
													   placeholder="-- Seleccione un Tipo --"
													   [ngClass]="displayFieldCssNgSelect('IdMedioTransporte')"
													   clearAllText="Eliminar selección"
													   (change)="onSelectTipoMedioTransporte()">
											</ng-select>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdMedioTransporte','required')">
												Tipo es obligatorio
											</div>
										</div>
										<!--Documento aduanero si no es PREDUA-->
										<div *ngIf="!esPredua" class="form-group col-md-6">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Documento aduanero</label>

											<i *ngIf="esAeropuerto && (IdPuntoInspeccion > 0 || editMode)" class="fa fa-info-circle icono-info-tooltip" placement="top" triggers="click" [autoClose]="'outside'" [ngbTooltip]="htmlTooltipSumaria1"></i>
											<i *ngIf="!esAeropuerto && (IdPuntoInspeccion > 0 || editMode)" class="fa fa-info-circle icono-info-tooltip" placement="top" triggers="click" [autoClose]="'outside'" [ngbTooltip]="htmlTooltipSumaria2"></i>
											<input [readonly]="IdPuntoInspeccion === 0" formControlName="NumeroDeclaracionSumaria"
												   name="NumeroDeclaracionSumaria" [ngClass]="displayFieldCss('NumeroDeclaracionSumaria')" title=""
												   class="form-control" [maxlength]="maxlenghtDecSumaria" id="" type="search" value="">

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NumeroDeclaracionSumaria','required')">
												Documento aduanero es obligatorio
											</div>
											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NumeroDeclaracionSumaria','minlength')">
												Documento aduanero tiene una longitud incorrecta
											</div>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NumeroDeclaracionSumaria','maxlength')">
												Documento aduanero tiene una longitud incorrecta
											</div>
										</div>
										<!--MRN si es PREDUA-->
										<div *ngIf="esPredua" class="form-group col-md-6">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">MRN</label>
											<i class="fa fa-info-circle icono-info-tooltip" placement="top" ngbTooltip="Mrn del predua asociado a la solicitud. Longitud: 18 caracteres"></i>
											<div class="input-group">
												<input [readonly]="deshabilitarMrn" formControlName="Mrn" name="Mrn" title="" class="form-control" [ngClass]="displayFieldCss('Mrn')" id="inpMrn" type="text" value="" maxlength="21">
												<span class="input-group-btn">
													&nbsp;<button [disabled]="!habilitarGuardar" name="btnContrastarPredua" class="btn btn-list btn-secondary" type="button" title="Contrastar PreDua"
																  (click)="onContrastarPredua()">
														<i class="fa fa-search"></i>
													</button>
												</span>
											</div>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Mrn','required')">
												Mrn es obligatorio
											</div>
											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Mrn','minlength')">
												Mrn debe tener 18 caracteres
											</div>
											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Mrn','maxlength')">
												Mrn debe tener 18 caracteres
											</div>

										</div>
										<div class="form-group col-md-3">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="inpFecha">Fecha / hora de llegada</label>
											<p-calendar formControlName="FechaLlegada" inputStyleClass="form-control" [ngClass]="displayFieldCssCal('FechaLlegada')"
														showTime="true" [showIcon]="true" hourFormat="24" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaLlegada','required')">
												Fecha / hora de llegada es obligatoria
											</div>
										</div>

									</div>
									<div class="row">
										<div class="form-group col-md-3">
											<label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Buque/Matrícula/AWB</label>
											<input formControlName="NumeroOMI" name="NumeroOMI" title="" maxlength="50" [ngClass]="displayFieldCss('NumeroOMI')"
												   class="form-control" id="" type="search" value="">

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NumeroOMI','required')">
												Buque/Matrícula/AWB es obligatorio
											</div>
										</div>

										<div class="form-group col-md-4">
											<label class="col-form-label" for="intEstado" [ngClass]="{ 'required-field' : paisRequiredMedioTransporte && campoObligatorio }">País medio transporte</label>
											<ng-select [items]="listPais"
													   bindLabel="Descripcion"
													   bindValue="Id"
													   formControlName="IdPaisMedioTransporte"
													   loadingText="Cargando..."
													   [readonly]="!listPais || listPais.length === 0"
													   [loading]="!listPais || listPais.length === 0"
													   notFoundText="País no encontrado"
													   placeholder="-- Seleccione un País --"
													   [ngClass]="displayFieldCssNgSelect('IdPaisMedioTransporte')"
													   clearAllText="Eliminar selección">
												<ng-template ng-option-tmp let-item="item">
													<div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
												</ng-template>

											</ng-select>

											<div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisMedioTransporte','required')">
												País es obligatorio
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div *ngIf="showWindowChedPpTraslado" class="row">
					<div class="col-md-12">
						<!--CHEDPP Traslado-->
						<div class="card card-accent-success animated fadeIn">
							<a class="card-header-a" (click)="isCollapsedCHEDPP = !isCollapsedCHEDPP" [attr.aria-expanded]="!isCollapsedCHEDPP" aria-controls="collapseExample">
								<div class="card-header-buscador">
									<i class="fa fa-file-text-o"></i> CHEDPP Traslado
									<i *ngIf="isCollapsedCHEDPP" class="fa fa-caret-down float-right"></i>
									<i *ngIf="!isCollapsedCHEDPP" class="fa fa-caret-up float-right"></i>
								</div>
							</a>
							<div class="card-body-detalle">
								<div class="collapse group-filtros" id="collapsedCHEDPP" [ngbCollapse]="isCollapsedCHEDPP">
									<div class="row">

										<div class="form-group col-md-6">
											<label class="col-form-label" for="inpChedPpTraslado">CHEDPP Traslado</label>
											<input class="form-control" formControlName="ChedPpTraslado" maxlength="50"
												   inputStyleClass="form-control" id="ChedPpTraslado" [ngClass]="displayFieldCss('ChedPpTraslado')">
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>


			</div>
		</div>
	</div>
</form>
